import BaseModal from 'components/BaseModal'
import _ from 'lodash'
import { MODAL_SIZE_MEDIUM } from 'constants/Layout'
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react'
import ProductAPI from 'restAPI/ProductAPI'
import SubProductAPI from 'restAPI/SubProductAPI'
import SubProductEnvironmentTypeAPI from 'restAPI/SubProductEnvironmentTypeAPI'
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI'
import { Form, Alert } from 'antd'
import ModalUtil from 'utils/modalUtil'
import { IntegrationType } from './common';
import { toolNameForAPI } from './GenericPullAndPushToolView';
import { generateFormFields } from 'utils/formUtils';
import { getCommonFields }  from './IngestionScriptFormPopup'
import WebhookTokenPopup from './WebhookTokenPopup'
import { useHasDisabledEnvironment } from 'contexts/GlobalSettingsContext'
const modalProps = {
    width: MODAL_SIZE_MEDIUM,
    // bodyStyle: {height: 500, paddingLeft: 90, paddingRight: 90, paddingTop: 90},
    style: { top: 80 },
}

const fieldName = ['product', 'subProduct', 'environment']

export default forwardRef(function WebHookGenerateFormPopup({name, ...props}, ref) {
    const isEdit = !!props.data;
    const isToolData = !!props.toolData
    const [products, setProducts] = useState();
    const [subProducts, setSubProducts] = useState([]);
    const [environments, setEnvironments] = useState([]);
    const [formData, setFormData] = useState({});
    const [form] = Form.useForm();
    const [succeeded, setSucceeded] = useState();
    const thisRef = useRef();
    const {hasDisabledEnvironment, envValue} = useHasDisabledEnvironment();
    const getProducts = useCallback(() =>{
        const { promise, cancel } = ProductAPI.getAllQuick();
        promise.then(setProducts, _.noop);
        return cancel;
    },[])
    

    const setInitialValue = (form, data) => {
        const { directory, environment, product_id, sub_product_id } = data;
        const initialProductId = +product_id || undefined;
        const initialSubProductId = +sub_product_id || undefined;
        form.setFieldsValue({ folder_name: directory, environment, product: initialProductId })
        const { promise: subProductPromise } = SubProductAPI.getAllQuick(product_id);
        subProductPromise.then(setSubProducts, _.noop);
        form.setFieldsValue({ subProduct: initialSubProductId })
        const { promise: environmentPromise } = SubProductEnvironmentTypeAPI.getAllQuick(sub_product_id);
        environmentPromise.then(response => {
            setEnvironments(response)
            const productionId = response.find(env => env.name === environment)?.id
            form.setFieldsValue({ environment:  productionId })
        })
    }
    useEffect(() => {
        getProducts();
    }, [getProducts]);
    useEffect(() => {
        if(isEdit && form){
            setInitialValue(form, props.data)
        }
    }, [isEdit, form,props.data])
    useEffect(() => {
        const params = new URLSearchParams(props.history.location.search);
        const paramMap = _.pickBy({
            product_id: params.get('product_id'),
            sub_product_id: params.get('sub_product_id'),
            environment: params.get('environment'),
        }, _.identity);

        if(isToolData && form){
            setInitialValue(form, props.toolData);
        }else if (isEdit && form){
            setInitialValue(form, props.data);
        } else if(form && !_.isEmpty(paramMap)) {
            setInitialValue(form, paramMap);
        }
    }, [props.data, isEdit, isToolData, form, props.toolData, props.history])
    
    useEffect(() => {
        if(formData.product && form){
            form.setFieldsValue({ subProduct:  undefined, environment: undefined });
            setSubProducts(null);
            const {promise, cancel} = SubProductAPI.getAllQuick(formData.product);
            promise.then(setSubProducts, _.noop);
            return cancel;
        }
    }, [formData.product, form]);
    useEffect(() => {
        if(formData.subProduct && form){
            form.setFieldsValue({ environment: undefined });
            setEnvironments(null);
            const {promise, cancel} = SubProductEnvironmentTypeAPI.getAllQuick(formData.subProduct);
            promise.then(response => {
                setEnvironments(response)
                const productionId = response.find(env => env.name === "Production")?.id
                form.setFieldsValue({ environment:  productionId })
            })
            return cancel;
        }
    }, [formData.subProduct, form])

    const tool = name.toLowerCase();
    useImperativeHandle(ref, () => ({ ...thisRef.current }));

    
    const processWebHookForm = useCallback(async () => {
        try{
            await form.validateFields()
            let { product, subProduct, environment} = form.getFieldsValue();
            if(hasDisabledEnvironment){
                environment = environments.find(env => env.name === envValue)?.id;
            }
            const _product = products.find(prd => prd.id === product)
            const _subProduct = subProducts.find(prd => prd.id === subProduct)
            let _environment = environments.find(env => env.id === environment)
                
            const tool_name = toolNameForAPI(name);
            const res = await ToolsIntegrationsAPI.webHookToolConfigurations({
                tool_name,
                product_name: _product.name,
                sub_product_name: _subProduct.name,
                environment: _environment.name,
                toolType: IntegrationType.WEBHOOK
            }).promise;
            setSucceeded(true);
            thisRef.current.close();
           
            const SuccessPopUp = props.WebhookSuccessComponent ? props.WebhookSuccessComponent : WebhookTokenPopup
            ModalUtil.show({
                content: <SuccessPopUp webhookTokenUrl={res.url} toolName={name} />
            })
        } catch (e) { 
            throw e;
        }
    },[products, subProducts, environments, form, name, props.WebhookSuccessComponent, hasDisabledEnvironment, envValue])
    
    const fields = _.filter(getCommonFields({products, subProducts, environments, isEdit, hasDisabledEnvironment}), field => fieldName.indexOf(field.name) !== -1)
    const title = isEdit ? `Edit ${name} Configuration` : `Configure ${name}`;
    return (
        <BaseModal
            modalProps={{...modalProps, title, onOk: processWebHookForm, okText: `Generate ${props.showOnlyToken ? 'Token' : 'URL'}`}}
            ref={thisRef}
            afterClose={() => props.afterClose(succeeded)}
        >
                <Form
                    layout="vertical"
                    form={form}
                    initialValues={{tool}}
                    onValuesChange={(data) => setFormData({...formData, ...data})}
                >
                    {generateFormFields(fields)}
                </Form>
                {["Lacework"].indexOf(name) !== -1 && <Alert type="warning" description={`The webhook will be configured for ${name} Notifications only`} />}
        </BaseModal>
    )
})
